"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight, Phone, Calendar } from "lucide-react";
const servicesLinks = [{
  title: "מטפל סיעודי פרטי",
  url: "/NursingCareNowPage"
}, {
  title: "צפה בכל השירותים",
  url: "/ServicesCitiesArticlesPage"
}];
const locations1 = [{
  title: "תל אביב",
  url: "/NursingCaregiverInTelAvivWithinFiveHoursPage"
}, {
  title: "רמת גן",
  url: "/NursingCaregiverInRamatGanWithinHoursPage"
}, {
  title: "חיפה",
  url: "/NursingCareProviderInHaifaWithinHoursPage"
}, {
  title: "ירושלים",
  url: "/NursingCareProviderInJerusalemWithinFiveHoursPage"
}, {
  title: "פתח תקווה",
  url: "/NursingCareProviderPetahTikvaWithinHoursPage"
}, {
  title: "נתניה",
  url: "/NursingCareProviderNetanyaWithinFiveHoursPage"
}, {
  title: "הרצליה",
  url: "/NursingCareProviderInHerzliyaWithinFiveHoursPage"
}, {
  title: "מודיעין",
  url: "/NursingCaregiverInModiinWithinFiveHoursPage"
}, {
  title: "ראשון לציון",
  url: "/NursingCaregiverInRishonLeZionWithinFiveHoursPage"
}, {
  title: "אשדוד",
  url: "/NursingCaregiverAshdodWithinHoursPage"
}];
const locations2 = [{
  title: "אשקלון",
  url: "/NursingCareProviderInAshkelonWithinFiveHoursPage"
}, {
  title: "חדרה",
  url: "/NursingCaregiverHodHasharonWithinHoursPage"
}, {
  title: "רחובות",
  url: "/NursingCareProviderRehovotPage"
}, {
  title: "כפר סבא",
  url: "/NursingCareProviderInKfarSabaWithinFiveHoursPage"
}, {
  title: "באר שבע",
  url: "/NursingCareProviderInBeershevaWithinHoursPage"
}, {
  title: "חולון",
  url: "#"
}, {
  title: "בת ים",
  url: "#"
}, {
  title: "גבעתיים",
  url: "#"
}, {
  title: "רעננה",
  url: "#"
}, {
  title: "צפה בכל האזורים",
  url: "/CitySpecificSEOPagesForNursingCareProviderPage"
}];
export default function FinalCta() {
  return <section data-section-id="260389" id="צרו-קשר" className="bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="max-w-3xl mx-auto text-center mb-16 md:mb-24">
          <h2 className="font-default text-3xl md:text-5xl font-bold mb-6 text-primary">
            זקוקים למטפל סיעודי באופן מיידי?
          </h2>
          <p className="font-default text-lg md:text-xl text-muted-foreground mb-8">
            אנחנו כאן בשבילכם. צרו קשר עכשיו לייעוץ ראשוני והתאמת מטפל מקצועי תוך 5 שעות בלבד, בכל רחבי הארץ.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Button asChild size="lg" className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 shadow-md">
              <Link to="/ContactPage">
                <Phone className="w-5 h-5" />
                התקשרו עכשיו
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="rounded-lg bg-transparent border-primary text-primary hover:bg-accent hover:text-accent-foreground shadow-sm">
              <Link to="/ContactPage">
                <SafeHydrate><Calendar className="w-5 h-5" /></SafeHydrate>
                תיאום פגישת ייעוץ
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-12 md:gap-8 pt-12 border-t border-border">
          {}
          <div className="flex flex-col gap-4">
            {servicesLinks.map((link, i) => <Link key={i} to={link.url} className="font-default text-sm text-muted-foreground hover:text-primary transition-colors" data-index={i}>
                {link.title}
              </Link>)}
          </div>

          {}
          <div className="flex flex-col gap-4">
            {locations1.map((link, i) => <Link key={i} to={link.url} className="font-default text-sm text-muted-foreground hover:text-primary transition-colors" data-index={i}>
                {link.title}
              </Link>)}
          </div>

          {}
          <div className="flex flex-col gap-4">
            {locations2.map((link, i) => <Link key={i} to={link.url} className="font-default text-sm text-muted-foreground hover:text-primary transition-colors" data-index={i}>
                {link.title}
              </Link>)}
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="font-default text-sm font-semibold text-foreground mb-2">הרשמה לניוזלטר</h3>
            <div className="relative border-b border-border pb-2 flex items-center">
              <input type="email" placeholder="האימייל שלך" className="font-default bg-transparent border-none outline-none w-full text-sm text-foreground placeholder:text-muted-foreground" />
              <Button variant="ghost" size="icon" className="text-muted-foreground hover:text-primary transition-colors ml-2 h-auto w-auto p-0">
                <ArrowRight className="w-4 h-4" />
                <span className="sr-only">הירשם</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}